export const CAT_CONTACTS = 1
export const CAT_COMMUNICATIONS = 2
